export const ALL_REGION_EVENTS_URL = '/events/?all_region=true';
export const DEFAULT_EVENTS_URL = '/events';

export const formFieldNames = [
  'name',
  'full_name',
  'email',
  'university',
  'gender',
  'degree',
  'field',
  'orgyear',
  'position',
  'other_position',
  'experience_years',
  'experience_months',
  'orgname',
  'whatsapp_consent',
  'terms_consent',
  'test_id',
  'mode',
  'graduation_year',
  'job_title',
];
